import React, { FC } from "react";

import "./App.css";
import Footer from "./components/Desktop/Footer";
import ArtistSection from "./components/Desktop/ArtistSection";
import Navigation from "./components/Desktop/Navigation";
import Hero from "./components/Desktop/Hero";
import ListenerSection from "./components/Desktop/ListenerSection";
import EarningsCalculatorSection from "./components/Desktop/EarningsCalculatorSection";

interface IDesktopProps {}

const Desktop: FC<IDesktopProps> = (props) => {
  return (
    <div 
      style={{ 
        backgroundColor: "#02162b", 
        minHeight: "100vh", 
        width: "100%", 
        margin: 0, 
        padding: 0,
        position: "relative",
        zIndex: 1,
      }}
    >
      <Navigation />
      <Hero />
      <ListenerSection />
      <EarningsCalculatorSection />
      <ArtistSection />
      <Footer />
    </div>
  );
};

export default Desktop;

